export function handleOpenLink(href?: string | null) {
  return () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer')
    }
  }
}
